import { animate, createDrawable, stagger } from '../vendor/anime.esm.js';
import { registerPostRender } from '../core/render.js';
import { store } from '../core/store.js';
import { DURATION, EASE, resolveDuration } from './motion-tokens.js';

// Track B (Ola 1.1): movimiento de dividers (parallax/morph). Se auto-registra
// como postRender. Importado aquí porque svg-draw lo cargan editor y público.
import './divider-motion.js';

// Track B (Ola 1.3): trazo SVG del bloque "journey" atado al scroll. Se
// auto-registra como postRender (previewOnly + editorOnly). Mismo motivo:
// svg-draw lo cargan los dos bundles (editor y público).
import './journey-scroll.js';

/**
 * SVG DRAW (Fase 1D)
 * Dibuja los trazos de los iconos vectoriales al hacer scroll.
 */

export function initSvgDraw() {
    const PREFERS_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (store.get('editorMode') || PREFERS_REDUCED_MOTION) return;

    // Buscamos los SVGs dentro de .block-icon-svg
    const iconContainers = document.querySelectorAll('.block-icon-svg svg');
    if (!iconContainers.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !entry.target.dataset.drawDone) {
                entry.target.dataset.drawDone = 'true';
                
                try {
                    // Seleccionar todas las primitivas dentro del SVG
                    const primitives = entry.target.querySelectorAll('path, line, polyline, circle, rect, polygon');
                    
                    if (primitives.length > 0) {
                        // Ocultar temporalmente para evitar destellos antes del dibujo
                        entry.target.style.opacity = '1';
                        
                        // Inferir el "peso narrativo" del bloque (BLOCK_ENERGY dinámico)
                        let baseDuration = DURATION.slow; // Default majestuoso para iconos grandes
                        let staggerDelay = 100;
                        
                        // Si el icono es pequeño (ej: feature-card, stat-item), debe ser rápido
                        if (entry.target.closest('.feature-card, .stat-item, .tl-card, .faq-item')) {
                            baseDuration = DURATION.normal;
                            staggerDelay = 50;
                        }
                        // Si el icono está en el Hero, debe ser extremadamente lento y premium
                        else if (entry.target.closest('.hero-section')) {
                            baseDuration = DURATION.slow * 1.5;
                            staggerDelay = 150;
                        }

                        primitives.forEach((prim, index) => {
                            // En Anime.js v4, createDrawable prepara el elemento para dibujar
                            const drawable = createDrawable(prim);
                            if (drawable) {
                                animate(drawable, {
                                    draw: ['0 0', '0 1'],
                                    duration: resolveDuration(baseDuration),
                                    ease: EASE.refined,
                                    delay: index * staggerDelay // Escalonar según el peso
                                });
                            }
                        });
                    }
                } catch (e) {
                    console.warn("Error en SVG Draw:", e);
                }
                
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 }); // Empezar a dibujar cuando el icono está al 50% visible

    iconContainers.forEach(svg => {
        // Inicializar SVG ocultando sus trazos
        svg.style.opacity = '0';
        observer.observe(svg);
    });
}

// Registrar en el ciclo de vida (solo preview)
registerPostRender(initSvgDraw, { previewOnly: true });
